import { render, staticRenderFns } from "./index2025.vue?vue&type=template&id=f6054056&scoped=true"
import script from "./index2025.vue?vue&type=script&lang=js"
export * from "./index2025.vue?vue&type=script&lang=js"
import style0 from "./index2025.vue?vue&type=style&index=0&id=f6054056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6054056",
  null
  
)

export default component.exports